import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authzContextAtom } from '../../../authorization/authzState';
import { userInformationAtom } from '../../../Services/_states';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { canCreateWorkspaceTable } from '../utils/canCreateWorkspaceTable';

/**
 * Resolves create-table permission for the active workspace route.
 */
export default function useCanCreateWorkspaceTable(explicitWorkspaceId, explicitAccountId) {
  const { workspaceId: routeWorkspaceId, accountId: routeAccountId } = useParams();
  const authz = useRecoilValue(authzContextAtom);
  const userInfo = useRecoilValue(userInformationAtom);
  const { userHasPermission } = ConstantActions();

  const workspaceId = explicitWorkspaceId || routeWorkspaceId;
  const accountId = explicitAccountId || routeAccountId;

  return useMemo(
    () => canCreateWorkspaceTable(authz, {
      workspaceId,
      accountId,
      userInfo,
      legacyUserHasPermission: userHasPermission,
    }),
    [authz, workspaceId, accountId, userInfo, userHasPermission]
  );
}
